import * as React from 'react';
import './ReturnsTable.scss';
import ReturnsRow from '../ReturnsRow';
import { IEligibleItem } from 'src/services/returns/typings';
import AlertCustom from 'src/components/common/AlertCustom';
import i18n from 'src/translation/i18n';
interface IReturnsTableProps {
  partsToReturn: IEligibleItem[];
  removeItemFromReturn: (id: number) => void;
  editPartFromReturnList: (part: IEligibleItem) => void;
}

const ReturnsTable: React.FC<IReturnsTableProps> = props => {
  const { partsToReturn, removeItemFromReturn, editPartFromReturnList } = props;
  const [isShowTableHistoryInfo, setIsShowTableHistoryInfo] = React.useState<boolean>(false);
  const [isShowTableHistoryInfoForRow, setIsShowTableHistoryInfoForRow] = React.useState<boolean>(true);

  React.useEffect(()=>{
    const partsInHistoryArr:any=[];
      partsToReturn.map((partToReturn, index) => {
        if(partToReturn.noOfTimesPartInvoicedInLast90Days>1){
          partsInHistoryArr.push(partToReturn.id);
        }
      });
      if(partsInHistoryArr.length>0){
        setIsShowTableHistoryInfo(true);
      }else{
        setIsShowTableHistoryInfo(false);
      }
    },[partsToReturn])

    const handleTableCloseAlert = () => {
      setIsShowTableHistoryInfo(false);
      setIsShowTableHistoryInfoForRow(false);
    }
  
    const removeAllPartsFromCart = () => {
      partsToReturn.map((partToReturn, index) => {
        if(partToReturn.noOfTimesPartInvoicedInLast90Days>1){
          removeItemFromReturn(partToReturn.id);
        }
      });
      setIsShowTableHistoryInfo(false);
    }

  return (
    <div className="rp-returns-table">
      {isShowTableHistoryInfo &&
          <div className="container-fluid">
          <div className="row">
            <AlertCustom
              type="lwarning"
              styleClass="rp-return-row-history-table-info--alert"
              icon={'icon="rpds-check-circle"'}
              handleCloseAlert={null}
              removeItemFromReturn={null}
              handleTableCloseAlert={handleTableCloseAlert}
              removeAllPartsFromCart={removeAllPartsFromCart}
              id={1}
              message={i18n.t('myReturns.removeAllPartFromReturnCartWarning')}
            />
            </div>
            </div>
        }
      {partsToReturn.map(partToReturn => (
        <ReturnsRow
          key={partToReturn.id}
          partToReturn={partToReturn}
          removeItemFromReturn={removeItemFromReturn}
          editPartFromReturnList={editPartFromReturnList}
          isShowTableHistoryInfoForRow={isShowTableHistoryInfoForRow}
        />
      ))}
    </div>
  );
};

export default ReturnsTable;
